import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from 'react'

const SlideUpPanel = forwardRef(
  (
    { children, header, ContainerBgColor = 'bg-white', direction = 'up' },
    ref,
  ) => {
    const [isOpen, setIsOpen] = useState(false)
    const [fixedClass, setFixedClass] = useState('')

    useImperativeHandle(ref, () => ({
      show: () => setIsOpen(true),
      hide: () => setIsOpen(false),
    }))

    useEffect(() => {
      setTimeout(() => {
        setFixedClass(isOpen ? 'fixed left-0 top-0' : null)
      }, 1000)
    }, [isOpen])

    // Determine transform class based on direction
    const getTransformClass = () => {
      if (!isOpen) {
        switch (direction) {
          case 'up':
            return 'translate-y-full'
          case 'down':
            return 'translate-y-[-100%]'
          case 'left':
            return 'translate-x-[-100%]'
          case 'right':
            return 'translate-x-full'
          default:
            return 'translate-y-full'
        }
      }
      return 'translate-y-0 translate-x-0'
    }

    // Position class based on direction
    const getPositionClass = () => {
      const baseClasses = 'fixed h-full w-full max-w-120 min-w-90'
      switch (direction) {
        case 'up':
          return `${baseClasses} bottom-0 left-0`
        case 'down':
          return `${baseClasses} top-0 left-0`
        case 'left':
          return `${baseClasses} top-0 left-0`
        case 'right':
          return `${baseClasses} top-0 right-0`
        default:
          return `${baseClasses} bottom-0 left-0`
      }
    }

    return (
      <div
        className={`transition-all duration-700 transform z-[1000] ${ContainerBgColor} ${getTransformClass()} ${getPositionClass()}`}
      >
        {!!header && (
          <div className="fixed top-0 right-2 z-[100]">{header}</div>
        )}
        {fixedClass && isOpen ? (
          <div
            className={`h-full w-full pb-5 overflow-auto`}
            style={{
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              WebkitOverflowScrolling: 'touch',
            }}
          >
            <div>{children}</div>
          </div>
        ) : (
          <div className="absolute h-screen w-screen flex items-center justify-center">
            Please wait...
          </div>
        )}
      </div>
    )
  },
)

export default SlideUpPanel
